import { ModelNode, ModelWriter, Plugin } from 'ckeditor5';

declare module '@ckeditor/ckeditor5-core/src/plugin' {
	// eslint-disable-next-line no-unused-vars
	interface PluginsMap {
		[ForceHttpsLinks.pluginName]: ForceHttpsLinks;
	}
}

class ForceHttpsLinks extends Plugin {
	public static get pluginName() {
		return 'ForceHttpsLinks' as const;
	}

	init() {
		const editor = this.editor;

		editor.model.document.on('change:data', () => {
			const model = editor.model;
			const doc = model.document;

			model.change((writer) => {
				for (const rootName of doc.getRootNames()) {
					const root = doc.getRoot(rootName);
					if (!root) continue;
					for (const value of root.getChildren()) {
						this.updateLinks(writer, value);
					}
				}
			});
		});
	}

	private updateLinks(writer: ModelWriter, element: ModelNode) {
		if (element.is('element')) {
			for (const child of element.getChildren()) {
				this.updateLinks(writer, child);
			}
		}

		if (element.hasAttribute('linkHref')) {
			const href = element.getAttribute('linkHref') as string;
			if (href && href.startsWith('http://')) {
				const secureHref = 'https://' + href.slice(7);
				writer.setAttribute('linkHref', secureHref, element);
			}
		}
	}
}

export default ForceHttpsLinks;
